// Global application constants — single source of truth
export const SUPPORT_EMAIL = 'contact@cmgworkflow.com';
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
